import React from 'react';
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString';
export const getRules = (tableData, tiers) => {
    if (tableData.type === 'MemberStreakDefault')
        return ['Membership streak badge'];
    if (tableData.type === 'Verified')
        return ['Verified staff members'];
    if (tableData.type === 'Custom') {
        return tableData.rules.map((rule) => {
            if (rule.type === 'CommentsWritten') {
                if (rule.minimum && rule.maximum) {
                    return `Wrote ${rule.minimum} to ${rule.maximum} comments`;
                }
                return `Wrote at least ${rule.minimum} comments`;
            }
            if (rule.type === 'LikesGiven') {
                if (rule.minimum && rule.maximum) {
                    return `Gave ${rule.minimum} to ${rule.maximum} likes`;
                }
                return `Gave ${rule.minimum} likes`;
            }
            if (rule.type === 'LikesReceived') {
                if (rule.minimum && rule.maximum) {
                    return `Received ${rule.minimum} to ${rule.maximum} likes`;
                }
                return `Received ${rule.minimum} likes`;
            }
            if (rule.type === 'GiftsGiven') {
                if (rule.minimum && rule.maximum) {
                    return `Gifted ${rule.minimum} to ${rule.maximum} subscriptions`;
                }
                return `Gifted ${rule.minimum} subscriptions`;
            }
            if (rule.type === 'FirstSubscribedAt') {
                if (rule.firstSubscribedAtFrom && rule.firstSubscribedAtTo) {
                    return (React.createElement(React.Fragment, null,
                        "Subscribed from",
                        ' ',
                        React.createElement(TimezonedDateString, { date: rule.firstSubscribedAtFrom, format: "MMM D, YYYY, h:mm A", withTimezoneAbbreviation: false }),
                        ' ',
                        "until",
                        ' ',
                        React.createElement(TimezonedDateString, { date: rule.firstSubscribedAtTo, format: "MMM D, YYYY, h:mm A", withTimezoneAbbreviation: false })));
                }
                if (rule.firstSubscribedAtFrom) {
                    return (React.createElement(React.Fragment, null,
                        "Subscribed from",
                        ' ',
                        React.createElement(TimezonedDateString, { date: rule.firstSubscribedAtFrom, format: "MMM D, YYYY, h:mm A", withTimezoneAbbreviation: false })));
                }
                if (rule.firstSubscribedAtTo) {
                    return (React.createElement(React.Fragment, null,
                        "Subscribed until",
                        ' ',
                        React.createElement(TimezonedDateString, { date: rule.firstSubscribedAtTo, format: "MMM D, YYYY, h:mm A", withTimezoneAbbreviation: false })));
                }
            }
            if (rule.type === 'ActiveMemberAt') {
                if (rule.activeMemberAtFrom || rule.activeMemberAtTo) {
                    return `Member active during selected period`;
                }
                return null;
            }
            if (rule.type === 'Tier') {
                const tier = tiers?.tiers.find((tier) => tier.id === rule.tierId);
                return `${tier ? tier.name : rule.tierId} members`;
            }
        });
    }
};
